import React, { useEffect, useState } from "react";
import CENpageUi from "./CENpageUi";
import Layout from "../../Components/Layout/Layout";
import { useAddCenMutation, useDeleteCenMutation, useEditCenMutation, useGetCenQuery } from "../../store/Api/cen";
import { useLocation, useNavigate } from "react-router-dom";
import { convertDDMMYYYY, hidetoast, useDecodeToken } from "../../Utils/function";
import {
  useGetCentresQuery,
  useGetCityQuery,
  useGetRrbQuery,
  useGetStatesQuery,
} from "../../store/Api/common";
import * as Yup from "yup";
import  {rowsPerPage} from '../../Utils/constant'
import { useDispatch, useSelector } from "react-redux";
const validationSchema = Yup.object().shape({
  name: Yup.string()
  .required("Name is required"),
});
function CENpage() {
  const navigate = useNavigate();
 
  const decodedToken = useDecodeToken();
  const [deleteId, setDeleteId] = useState("");
  const [deleteCen] = useDeleteCenMutation();
  const [tableQaury, setTableQaury] = useState({
    search: "",
    rowsPerPage: rowsPerPage,
    currentPage: 1,
  });
  const [addCen] = useAddCenMutation();
  const [updateCen] = useEditCenMutation();
const [updateData,setUpDateData] = useState("");
  const { data, isFetching, isLoading, refetch } = useGetCenQuery({
    search: tableQaury.search,
    limit: tableQaury.rowsPerPage,
    page: tableQaury.currentPage,
  });
  
  const dispatch = useDispatch();
  const toast = useSelector((state) => state.toast);
  const location = useLocation(); // Access state
  const  state  = location?.state;
  const [showForm,setShowForm] = useState(state?.showModal ? true :false);

  // Auto-hide toast after 3 seconds
 useEffect(() => {
    if (toast.message) {
       hidetoast()
    }
  }, [toast.message, dispatch]);

  const onUpdate = (data) => {
    navigate(`/update-cen/${data?.id}`, { state: { data } });
  };
  const deleteCenFn = async () => {
    try {
      const response = await deleteCen({ id: deleteId });
      if (response?.data?.success) {
        refetch();
      }
    } catch (error) {
      console.log(error, "verify otp error");
    }
  };
  useEffect(() => {
      refetch();
  }, [tableQaury]);
  const handlePageChange = (newPage) => {
    // setCurrentPage(newPage);
    setTableQaury({ ...tableQaury, currentPage: newPage });
  };
  const formatDate = (isoDateString) => {
    const date = new Date(isoDateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const columns = [
    { title: "CEN", dataKey: "name" },
    // ...(decodedToken?.role === 3
    //   ? [{ title: "RRB", dataKey: "rrb", isObject: true, objectKey: "name" }]
    //   : []),
    // { title: "State", dataKey: "state", isObject: true, objectKey: "name" },
    // { title: "City", dataKey: "city", isObject: true, objectKey: "name" },
    // { title: "Center", dataKey: "centre", isObject: true, objectKey: "name" },
    { title: "Created At", 
      render: (_, row) => (
      <span>{formatDate(row?.createdAt)}</span>
      )
     },
    {
      title: "Actions",
      render: (_, row) => (
        <div className="d-flex">
          {/* <button className="border-0 bg-transparent">
            <i class="fas fa-eye text-primary"></i>
          </button> */}
          <button
            className="border-0 bg-transparent"
            type="button"
            onClick={() => {setUpDateData(row);setShowForm(true) }}
          >
            <i className="fas fa-edit text-success"> </i>
          </button>
          <button
            className="border-0 bg-transparent"
            type="button"
            data-toggle="modal"
            data-target="#modal-danger"
            onClick={() => setDeleteId(row?.id)}
          >
            <i className="fas fa-trash text-danger"> </i>
          </button>
        </div>
      ),
    },
  ];
  const submitfrom= async (values, { resetForm })=>{
    const data = values
  try {
      const response = updateData?.id ? await updateCen({ id:updateData?.id , data }):  await addCen({ ...data })
      if (response?.data?.success) { 
        setShowForm(false);
      }
    } catch (error) {
      console.log(error, "verify otp error");
    }
}
  return (
    <Layout>
      <CENpageUi
        columns={columns}
        data={data?.data?.data || []}
        totalRecords={data?.data?.totalItems}
        onUpdate={onUpdate}
        loading={isLoading}
        tableQaury={tableQaury}
        onPageChange={handlePageChange}
        deleteFn={deleteCenFn}
        setTableQaury={setTableQaury}
        decodedToken={decodedToken}
        toast={toast}
        validationSchema={validationSchema}
        setShowForm={setShowForm}
        showForm={showForm}
        submitfrom={submitfrom}
        setUpDateData={setUpDateData}
        updateData={updateData}
      />
    </Layout>
  );
}

export default CENpage;
